'use client'

import SVGShare from '@img/share.svg'
import { detail } from '@lib/route/event'
import { useLocale, useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'

const ShareDropdown = dynamic(() => import('@comp/share'), {
  ssr: false,
  loading: () => <ShareTrigger />
})

export default function ShareButton({
  data
}) {
  const locale = useLocale()

  return (
    <ShareDropdown
      trigger={
        <ShareTrigger />
      }
      shareData={{ url: detail(data, locale), title: data.name }}
    />
  )
}
function ShareTrigger() {
  const ts = useTranslations('common')
  return (
    <div className="flex items-center justify-center border border-primary w-pix-75 py-1 bg-white text-primary rounded-xl">
      <SVGShare className="w-pix-18 h-pix-16 mr-pix-4" />
      {ts('share')}
    </div>
  )
}
